<div class="fondo-dialogo-pagos">
</div>
<div class="container-dialogo-pagos">
  <div class="dialogo-pagos">
    <div class="titulo-dialogo-pagos">
      <h3>Administración</h3>
      <p>Comprobante de pago</p>
    </div>
    <div class="contenido-dialogo-pagos">
      <img src="https://image.isu.pub/190626212728-90663b21b8942294e9629e9a422c193a/jpg/page_1_thumb_large.jpg" alt="">
      <div class="items-dialogo-pagos">
        <span style="font-weight: bold;">
          Nombre residente:
        </span>
        <span style="font-weight: bold;">
          Torre - apt/ casa:
        </span>
        <span style="font-weight: bold;">
          Valor pago:
        </span>
        <span style="font-weight: bold;">
          Fecha de captura:
        </span>
        <span>
          Anton Brownstein
        </span>
        <span>
          1 - 104
        </span>
        <span>
          {{510000 | currency}}
        </span>
        <span>
          16-04-2020 05:30 pm
        </span>
      </div>
      <app-botones-cambios></app-botones-cambios>
    </div>
  </div>
</div>
